/**
 * @generated SignedSource<<bce5d7d3b711e8864302dfcbfc5d2670>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultsCql_AtlassianSearchPage$data = {
  readonly confluence_search: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ConfluenceSearchResponse";
        readonly content: {
          readonly ari: string | null;
        } | null;
        readonly url: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"searchResultCql_AtlassianSearchPage">;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "searchResultsCql_AtlassianSearchPage";
};
export type searchResultsCql_AtlassianSearchPage$key = {
  readonly " $data"?: searchResultsCql_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultsCql_AtlassianSearchPage">;
};

import SearchResultsCQLPaginationQuery_graphql from './SearchResultsCQLPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "confluence_search"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "cql"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SearchResultsCQLPaginationQuery_graphql
    }
  },
  "name": "searchResultsCql_AtlassianSearchPage",
  "selections": [
    {
      "alias": "confluence_search",
      "args": [
        {
          "kind": "Variable",
          "name": "cql",
          "variableName": "cql"
        }
      ],
      "concreteType": "ConfluenceSearchConnection",
      "kind": "LinkedField",
      "name": "__SearchResultsCQLPagination__confluence_search_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceSearchResponseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "ConfluenceSearchResponse",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                },
                {
                  "kind": "ScalarField",
                  "name": "url"
                },
                {
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "ari"
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "searchResultCql_AtlassianSearchPage"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "51b24e33621d3475cf8b3ace0b87f653";

export default node;
